module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"check":"Вы не дали разрешение на доступ к камере или микрофону.","p1":"Слева от адреса сайта нажмите на значок замка","p2":"Разрешите доступ к камере и микрофону;","p3":"Обновите страницу","p3.check":"или нажмите сюда"}}')
  delete Component.options._Ctor
}
